import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { useSidebar } from '@/components/ui/sidebar'

export function CompanySwitcherSkeleton() {
  const { state } = useSidebar()
  const isCollapsed = state === 'collapsed'

  return (
    <Button
      variant="outline"
      className={cn(
        'w-full justify-between transition-all duration-200',
        isCollapsed && 'w-8 p-0',
      )}
      disabled
    >
      <div
        className={cn(
          'flex items-center gap-2 ',
          isCollapsed && 'justify-center w-full',
        )}
      >
        <div className="flex -ml-1 h-6 w-6 shrink-0 items-center justify-center rounded-xl border bg-muted animate-shimmer" />
        {!isCollapsed && (
          <div className="h-4 w-24 rounded bg-muted animate-shimmer" />
        )}
      </div>
    </Button>
  )
}
